import newestprobanner2 from '../../img/New_Banner1920x100_RHTS.png';
import React, { Component } from 'react';
import { Image } from 'semantic-ui-react'
import '../Header.css';
import SmoothImage from 'react-smooth-image';

class Header extends Component {




    render() {
        const divStyle = {
            paddingBottom: 200
        };

        return (

            <header>
                <SmoothImage
                    src={newestprobanner2}
                    alt="header"
                    transitionTime={.5}
                    containerStyles={divStyle}
                //Other props if you choose to use them
                />
            </header>


        );
    }
}
export default Header;

